import {composeWithDevTools} from '@redux-devtools/extension';
import {
  type StoreEnhancer,
  configureStore as configureAppStore,
} from '@reduxjs/toolkit';
import {createInjectorsEnhancer} from 'redux-injectors';
import createSagaMiddleware from 'redux-saga';
import createReducer from './reducers.js';

export default function configureStore() {
  const reduxSagaMonitorOptions = {};
  const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);
  const {run: runSaga} = sagaMiddleware;
  const composeEnhancers = composeWithDevTools({});

  // Create the store with saga middleware
  const middlewares = [sagaMiddleware];

  const enhancers = [
    createInjectorsEnhancer({
      createReducer,
      runSaga,
    }),
    composeEnhancers(),
  ] as StoreEnhancer[];

  const store = configureAppStore({
    reducer: createReducer(),
    middleware: (defaultMiddleware) => [...defaultMiddleware(), ...middlewares],
    enhancers,
  });

  return store;
}
